import React, { useEffect, useState } from "react";
import { AddFlex, CustomText } from "../../reusableStyles";
import {
  Instagram,
  Mail,
  Phone,
  QuestionAnswerOutlined,
  Send,
  Share,
  Warning,
} from "@mui/icons-material";
import { primaryActionColor, primaryActionColorLight } from "../../constants";
import {
  capitalizeWords,
  isStringNullOrUndefined,
  isValidImage,
} from "../../utils";
import useWindowSize from "../../Hooks/useWindowSize";
import NextPost from "../../ImageAssets/NextPost.png";
import NextStory from "../../ImageAssets/NextStory.png";
import { callNonStoreApi } from "../../NonStoreApis";
import { useSelector } from "react-redux";
import axios from "axios";
import { Skeleton } from "antd";
import { UpdateMediaUrlApi } from "../../Api/ApiEndPoints";

const stats = {
  followers: {
    name: "Followers Gained",
    bg: "#8319FE0D",
    color: "#8319FE",
    icon: <Instagram />,
  },
  comments: {
    name: "Total Comments",
    bg: primaryActionColorLight,
    color: primaryActionColor,
    icon: <QuestionAnswerOutlined />,
  },
  phoneNumber: {
    name: "Phone numbers",
    bg: "#E2D9F759",
    color: "#684EA6",
    icon: <Phone />,
  },
  email: {
    name: "Emails",
    bg: "#8D0B410D",
    color: "#8D0B41",
    icon: <Mail />,
  },
  share: {
    name: "Shares",
    bg: "#8D0B410D",
    color: "#8D0B41",
    icon: <Send />,
  },
  story: {
    name: "Story Interactions",
    bg: "#8D0B410D",
    color: "#8D0B41",
    icon: <Mail />,
  },
};

function AutomationCard({ media, tabIndex, updateMediaUrl, onClick }) {
  const { isMobileView } = useWindowSize();
  const { credentials } = useSelector((state) => state.instagram);
  const [loading, setLoading] = useState(true);
  const [mediaUrl, setMediaUrl] = useState("");

  const fetchMediaImage = async () => {
    try {
      if (media.mediaData.isNextPost) {
        if (media.mediaData.isStory) {
          setMediaUrl(NextStory);
        } else {
          setMediaUrl(NextPost);
        }
      } else {
        if (media.mediaData.type === "all") {
          setMediaUrl(media.mediaData.mediaUrl);
        } else {
          console.log("called");
          const result = await isValidImage(media.mediaData.mediaUrl);
          if (result) {
            setMediaUrl(media.mediaData.mediaUrl);
          } else {
            throw new Error("Media not loading");
          }
        }
      }
    } catch (error) {
      try {
        const mediaData = await axios.get(
          `https://graph.instagram.com/${media.mediaData.mediaId}/?fields=id,media_type,media_url,thumbnail_url&access_token=${credentials.access_token}`
        );

        const url =
          mediaData.data.media_type === "VIDEO"
            ? mediaData.data.thumbnail_url
            : mediaData.data.media_url;
        setMediaUrl(url);
        await callNonStoreApi(UpdateMediaUrlApi, {
          mediaId: mediaData.data.id,
          mediaUrl: url,
        });
        updateMediaUrl(mediaData.data.id, url);
        // api call to update media_url
      } catch (error) {
        setMediaUrl("");
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMediaImage();
  }, [tabIndex]);
  return (
    <AddFlex
      padding="8px"
      borderRadius="8px"
      gap="10px"
      width={isMobileView() ? "100%" : "31%"}
      backgroundColor="white"
      style={{
        border: "1px solid #ececec",
        boxShadow: "0 0 1px 2px rgba(0,0,0,0.05)",
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <CustomText
        style={{
          position: "absolute",
          right: "10px",
          bottom: "10px",
          fontSize: "12px",
        }}
      >
        Edit
      </CustomText>
      <AddFlex
        borderRadius="25px"
        padding="5px 10px"
        alignItems="center"
        style={{
          position: "absolute",
          right: "10px",
          fontSize: "12px",
          fontWeight: "600",
          backgroundColor: media.status === "live" ? "#DCFCE8" : "#BCCCDC80",
          color: media.status === "live" ? "#166534" : "grey",
        }}
        gap="3px"
      >
        {capitalizeWords(media.status)}
      </AddFlex>
      {loading ? (
        <Skeleton.Node />
      ) : isStringNullOrUndefined(mediaUrl) ? (
        <AddFlex
          alignItems="center"
          justify="center"
          style={{
            width: "72px",
            height: "80px",
            borderRadius: "8px",
            objectFit: "cover",
            backgroundColor: "#ececec",
          }}
        >
          <Warning sx={{ fontSize: "22px", color: "grey" }} />
        </AddFlex>
      ) : (
        <img
          src={
            media.mediaData.isNextPost
              ? media.mediaData.isStory
                ? NextStory
                : NextPost
              : mediaUrl
          }
          style={{
            width: "72px",
            height: "80px",
            borderRadius: "8px",
            objectFit: "cover",
          }}
        />
      )}

      {media.stats && (
        <AddFlex gap="4px" flexDirection="column">
          {Object.entries(media.stats).map(([key, value]) =>
            stats[key] ? (
              <AddFlex
                gap="6px"
                padding="3px 10px"
                borderRadius="25px"
                backgroundColor={stats[key].bg}
                alignItems="center"
                style={{ width: "max-content" }}
              >
                {React.cloneElement(stats[key].icon, {
                  sx: {
                    color: stats[key].color,
                    fontSize: "12px",
                  },
                })}
                <CustomText color={stats[key].color} fontSize="12px">
                  {`${stats[key].name} : ${value.total?.count}`}
                </CustomText>
              </AddFlex>
            ) : (
              <></>
            )
          )}
        </AddFlex>
      )}
    </AddFlex>
  );
}

export default AutomationCard;
